"use strict";
/* global jQuery */
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var Hammer = require("hammerjs");
var Clipboard = require("clipboard");
window.angular = angular;
window.Hammer = Hammer;
window.Clipboard = Clipboard;
